import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungNuernberg() {
  return (
    <CityPageTemplate
      city="Nürnberg"
      slug="nuernberg"
      intro="Nürnberg ist ein starker Wirtschaftsstandort – lass Dein Geld genauso hart arbeiten wie Du."
      description="Unabhängige Finanzberatung für Nürnberg – 100% digital, kostenlose Erstberatung. Altersvorsorge, ETF, Steueroptimierung & staatliche Förderungen."
    />
  );
}
